
import { useEffect, useState, } from "react";
import api from '../../../../services/api';
import { InputBase } from "@mui/material";
import HeaderSession from "../../../../utils/headerSession";
import ListaNotificacoes from "./listaNotificacoes";
import { useLocation, useParams, useSearchParams } from "react-router-dom";


export default function Notificacoes() {
    const { status } = useParams()
    const [notificacoes, setNotificacoes] = useState('')
    const [configLista, setConfigLista] = useState('')
    const [perPage, setPerPage] = useState(50)
    const [filter, setFilter] = useState('')
    // const [openForm, setOpenForm] = useState(false)
    const [searchParams] = useSearchParams();
    const [page, setPage] = useState(searchParams.get("page"));
    const location = useLocation();


    useEffect(() => {
        setNotificacoes('');
       
        api.get(`/farmaco-vigilancias?status=${status}&page=${page}&perPage=${perPage}`)
            .then(response => {
                // console.log(response)
                setNotificacoes(response.data.famacoVigilancias);
                setFilter(response.data.famacoVigilancias);
                setConfigLista(response.data);

                localStorage.setItem('urlAnterior', location.pathname + location.search); 
            }).catch(err => '')
    }, [page, status, perPage])

    const filterNotificacoes = (valor) => {
        setNotificacoes(filter.filter((espedienteGeral) => (espedienteGeral?.nome?.toLowerCase().includes(valor.toLowerCase()))))
    }

    return (
        <div>
            <HeaderSession title={`NOTIFICAÇÕES / ${status?.toLocaleUpperCase()}`} />

            <div style={{ display: 'flex', marginBottom: 20 }}>

                <InputBase
                    style={{ width: '70%', border: '1px solid #85287e', borderRadius: 5, paddingLeft: 20 }}
                    sx={{ ml: 1, flex: 1 }}
                    autoFocus
                    placeholder="Filtro"
                    inputProps={{ 'aria-label': 'Filtrar lista' }}
                    onChange={(e) => { filterNotificacoes(e.target.value) }}
                />
            </div>

            <ListaNotificacoes
                notificacoes={notificacoes}
                page={page}
                setPage={setPage}
                setPerPage={setPerPage}
                configLista={configLista}
            />
        </div>
    )
}
